var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-6" }, [
    _c(
      "div",
      {
        staticClass:
          "content-tabs text-center border border-bottom-0 border-gray-500",
      },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "div",
          {
            staticClass: "d-inline-block w-50 content-tabs-item",
            class: { active: _vm.isSelected(tab) },
            on: {
              click: function ($event) {
                return _vm.onTabSelect(tab)
              },
            },
          },
          [
            _c("div", { staticClass: "pt-2 pb-2" }, [
              _c("h5", {
                staticClass: "mb-0",
                domProps: { textContent: _vm._s(tab.title) },
              }),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "border border-top-0 border-gray-500" },
      [
        _vm.hasSendListSelected
          ? _c(_vm.activeComponent, {
              key: _vm.componentKey,
              tag: "component",
              staticClass: "p-2",
              attrs: { "send-list": _vm.sendList },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }